import { useEffect, useRef } from "react";
import { useSite } from "@/context/SiteContext";

export default function InfoDialog() {
  const { info, closeInfo } = useSite();
  const ref = useRef(null);
  useEffect(() => {
    if (info.open) ref.current?.showModal();
    else ref.current?.close();
  }, [info.open]);
  return (
    <dialog ref={ref} data-testid="info-dialog" onClick={(e) => { if (e.target === ref.current) ref.current.close(); }}>
      <button className="close" aria-label="Close dialog" onClick={closeInfo}>×</button>
      <span className="eyebrow">{info.kicker}</span>
      <h2>{info.title}</h2>
      <div>
        <p style={{ fontSize: 13, lineHeight: 1.8 }}>{info.body}</p>
      </div>
      <button className="btn" onClick={closeInfo}>Got it</button>
    </dialog>
  );
}
